import { request } from "./request"

export const commentsApi = {
  getCommentsByNodeId: async (userID: number, nodeId: string, signal?: AbortSignal) => {
    return request('GET', `/api/2/users/${userID}/fs/root/nodes/${nodeId}/comments`, { preview: true, preview_jwt: true }, { signal })
  },

  createComment: async (userID: number, nodeId: string, data: { message: string, parent_id?: number, annotation?: any }): Promise<any> => {
    return request('POST', `/api/2/users/${userID}/fs/root/nodes/${nodeId}/comments`, data)
  },

  createSharedComment: async (userID: number, sharedId: string, nodeId: string, data: { message: string, parent_id?: number, annotation?: any }): Promise<any> => {
    return request('POST', `/api/2/users/${userID}/shared_with_me/fs/${sharedId}/nodes/${nodeId}/comments`, data)
  },

  deleteComment: async (userID: number, nodeId: string, commentId: number): Promise<any> => {
    return request('DELETE', `/api/2/users/${userID}/fs/root/nodes/${nodeId}/comments/${commentId}`)
  },

  deleteSharedComment: async (userID: number, sharedId: string, nodeId: string, commentId: number): Promise<any> => {
    return request('DELETE', `/api/2/users/${userID}/shared_with_me/fs/${sharedId}/nodes/${nodeId}/comments/${commentId}`)
  },

  updateComment: async (userID: number, nodeId: string, commentId: number, data: { message?: string, mentions?: any, status?: 'open' | 'resolved' }): Promise<any> => {
    return request('PATCH', `/api/2/users/${userID}/fs/root/nodes/${nodeId}/comments/${commentId}`, data)
  },

  updateSharedComment: async (userID: number, sharedId: string, nodeId: string, commentId: number, data: { message?: string, mentions?: any, status?: 'open' | 'resolved' }): Promise<any> => {
    return request('PATCH', `/api/2/users/${userID}/shared_with_me/fs/${sharedId}/nodes/${nodeId}/comments/${commentId}`, data)
  },

  getCommentById: async (userID: number, nodeId: string, commentId: string, signal?: AbortSignal): Promise<any> => {
    return request('GET', `/api/3/users/${userID}/fs/root/nodes/${nodeId}/comments/${commentId}`, { preview: true, preview_jwt: true }, { signal })
  },

  getSharedCommentById: async (userID: number, sharedId: string, nodeId: string, commentId: string, signal?: AbortSignal): Promise<any> => {
    return request('GET', `/api/3/users/${userID}/shared_with_me/fs/${sharedId}/nodes/${nodeId}/comments/${commentId}`, { preview: true, preview_jwt: true }, { signal })
  },
}
